// 专业级开发工具API
import request from '@/api'

// 专业级开发工具列表
export async function getProfessionalLevelLsit(data) {
  return request({
    url: '/capi/app-service/Catalogue/selectAllList',
    method: 'post',
    data
  })
}

// 创建目录
export async function addCatalogue(data) {
  return request({
    url: '/capi/app-service/Catalogue/add',
    method: 'post',
    data
  })
}

// 删除目录
export async function delCatalogue(data) {
  return request({
    url: '/capi/app-service/Catalogue/del',
    method: 'post',
    data
  })
}

// 修改目录
export async function catalogueUpdate(data) {
  return request({
    url: '/capi/app-service/Catalogue/update',
    method: 'post',
    data
  })
}

// 查询目录
export async function selectCatalogue(data) {
  return request({
    url: '/capi/app-service/Catalogue/selectCatalogueColumn',
    method: 'post',
    data
  })
}

// 删除应用
export async function delApp(data) {
  return request({
    url: '/capi/app-service/app/delApp',
    method: 'post',
    data
  })
}

// 应用移动
export async function appMove(data) {
  return request({
    url: '/capi/app-service/app/AppMove',
    method: 'post',
    data
  })
}

// 应用克隆
export async function appCloneScene(data) {
  return request({
    url: '/capi/app-service/app/cloneScene',
    method: 'post',
    data
  })
}

// 修改应用
export async function addorupdata(data, type) {
  return request({
    url: `/capi/app-service/app/app/addorupdata/${type}`,
    method: 'post',
    data
  })
}

// 查询某个目录下的应用
export async function selectUnallApp(data) {
  return request({
    url: `/capi/app-service/app/selectUnallApp`,
    method: 'post',
    data
  })
}

// SIL历史测试报告
export async function selectallTask(data) {
  return request({
    url: `/capi/app-service/task/selectall`,
    method: 'post',
    data
  })
}

// 查询特定目录信息
export async function selectOneCatalogue(data) {
  return request({
    url: `/capi/app-service/Catalogue/selectOneCatalogue`,
    method: 'post',
    data
  })
}

// 查询特定目录信息
export async function moduleRela(data) {
  return request({
    url: `/capi/app-service/app/moduleRela`,
    method: 'post',
    data
  })
}

// 查询当前用户是否存在专业级权限
export async function isShowTadSim(data) {
  return request({
    url: `/capi/app-service/app/isShowTadSim`,
    method: 'post',
    data
  })
}

// 查询模板或示例列表
export async function selectAppModel(data) {
  return request({
    url: `/capi/app-service/app/selectAppModel`,
    method: 'post',
    data
  })
}

// 查询模板或示例详情
export async function selectAppModelDetails(data) {
  return request({
    url: `/capi/app-service/app/selectAppModelById`,
    method: 'post',
    data
  })
}
